var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"mdi mr-1 font-size-18",class:_vm.featured ? 'mdi-star text-primary' : 'mdi-star-outline text-muted',attrs:{"title":_vm.featured ? 'Destacado' : 'No destacado'}})
}
var staticRenderFns = []

export { render, staticRenderFns }